"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsS3BucketDestination_1 = require("./_AnalyticsS3BucketDestination");
exports._AnalyticsExportDestination = {
    type: "structure",
    required: ["S3BucketDestination"],
    members: {
        S3BucketDestination: {
            shape: _AnalyticsS3BucketDestination_1._AnalyticsS3BucketDestination
        }
    }
};
//# sourceMappingURL=_AnalyticsExportDestination.js.map